import React from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';

import styles from './styles.css';

class SubtitlesButton extends React.Component {
  constructor(props) {
    super(props);
    this.player = props.xingPlayer.videojs;
    this.state = { subtitles: this.initSubtitles() };
    this.enableSubtitleByDefault();
  }

  initSubtitles = () => {
    let subtitles = [];
    for (let i = 0; i < this.props.subtitles.length; i++) {
      subtitles.push({
        id: this.player.addRemoteTextTrack(
          {
            kind: 'captions',
            label: this.props.subtitles[i].label,
            src: this.props.subtitles[i].sources?.find(
              (s) => s.type === 'WEBVTT'
            )?.source,
            mode: 'hidden',
            id: 'track_' + i,
          },
          false
        ).track.id,
        label: this.props.subtitles[i].label,
        selected: false,
      });
    }
    subtitles.push({
      id: 'none',
      label: 'none',
      selected: true,
    });
    return subtitles;
  };

  enableSubtitleByDefault = () => {
    if (this.props.shouldDisplaySubtitle) {
      const defaultIndex = this.props.subtitles.findIndex(
        (sub) => sub.label.toLowerCase() === 'de'
      );
      defaultIndex >= 0 &&
        this.changeSubtitle(this.state.subtitles[defaultIndex]);
    }
  };

  changeSubtitle = (item) => {
    const tracks = this.player.textTracks();
    let subtitles = this.state.subtitles;

    for (let i = 0; i < subtitles.length; i++) {
      const track =
        tracks[findIndex(tracks, (track) => track.id === subtitles[i].id)];
      if (subtitles[i].id === item.id) {
        track && (track.mode = 'showing');
        subtitles[i].selected = true;
      } else {
        track && (track.mode = 'hidden');
        subtitles[i].selected = false;
      }
    }
    this.setState(subtitles);
  };

  updateMenu = () => {
    this.props.xingPlayer.setMenu('subtitle', this.state.subtitles, (item) =>
      this.changeSubtitle(item)
    );
  };

  render() {
    if (this.state.subtitles.length <= 1) {
      return null;
    }
    return (
      <div className={styles.buttonContainer}>
        <button
          className={
            styles.button + ' vjs-xing-subtitles vjs-control vjs-button'
          }
          type="button"
          onClick={() => this.updateMenu()}
        >
          <span aria-hidden="true" className="vjs-icon-placeholder" />
        </button>
      </div>
    );
  }
}

SubtitlesButton.propTypes = {
  xingPlayer: PropTypes.object.isRequired,
  subtitles: PropTypes.any,
  shouldDisplaySubtitle: PropTypes.bool,
};

export default SubtitlesButton;
